import axiosInstance from "@/api/axios-instance";
import { FormDetails } from "@/pages/forms/types/form";

export async function getForm(id: string): Promise<FormDetails> {
  const response = await axiosInstance.get(`/forms/${id}`);
  return response.data as FormDetails;
}
